export const BACKEND_URL = "https://rehi01.skp-dp.sde.dk/portfolio-backend";
export const API_BASE_URL = `${BACKEND_URL}/api`;
